import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const container = document.getElementById("root");
const appTree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Prerendered snapshots (see scripts/prerender.js) leave real markup inside
// #root, so hydrate over it instead of clobbering it with a fresh render.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, appTree);
} else {
  ReactDOM.createRoot(container).render(appTree);
}
